import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBaseComponent } from '../component/form-base/form-base.component';
import { FormTemplateComponent } from '../component/form-template/form-template.component';


@Injectable()
export class FormBuildService {

  private catalogue: { [key: string]: any } = {};

  constructor(public componentFactoryResolver: ComponentFactoryResolver) { }

  addComponent(key: string, component: any) {
    this.catalogue[key] = component;
  }

  private getComponent(key: string) {
    return this.catalogue[key];
  }

  build(key: string, noID: boolean, host: ViewContainerRef, form: FormGroup) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponent(key));
    const viewContainerRef = host;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormTemplateComponent>componentRef.instance).parent = form;
    (<FormTemplateComponent>componentRef.instance).noID = noID;
    (<FormTemplateComponent>componentRef.instance).combine = true;
    return componentRef;
  }
};



// WEBPACK FOOTER //
// ./src/app/form/core/service/form-build.service.ts